<template>
  <div class="page">
    <YorkbbsHeader></YorkbbsHeader>
    <!-- Edward 增加的顶部广告 2025-01-15-->
    <YorkbbsSkeleton class="kjwt-skeleton row" :count="1" :loading="advLoading">
      <div slot="template" class="kjwt-skeleton__item">
        <el-skeleton-item variant="image"></el-skeleton-item>
      </div>
    </YorkbbsSkeleton>
    <!-- 广告 -->
    <div class="kjwt-row" v-show="!advLoading">
      <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`top_${i}`]"></YorkbbsAdvItem>
    </div>

    <div class="page-wrapper">
      <!-- 面包屑 -->
      <el-skeleton :loading="loading" animated>
        <template slot="template">
          <el-skeleton-item variant="p" style="height: 34px; margin:20px 0 " />

        </template>
      </el-skeleton>
      <!---信息管理-->
      <CarManagement :post="post" v-if="post.id" />
      <YorkbbsAuthorManager :post="post" v-if="post.id"></YorkbbsAuthorManager>
      <YorkbbsBreadcrumb v-if="post.id">
        <el-breadcrumb-item to="/">约克汽车</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/list/${post.property.topics[0].englishName}`">{{
          post.property.topics[0].name
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>详情页</el-breadcrumb-item>
      </YorkbbsBreadcrumb>
    </div>
    <main class="page-main">
      <div class="page-left">
        <!-- 轮播图 -->
        <el-skeleton :loading="loading" animated>
          <template slot="template">
            <el-skeleton-item variant="image" style="height: 398px;" />
            <el-skeleton-item variant="image" style="height: 60px; margin:20px 0" />

          </template>
        </el-skeleton>
        <YorkbbsThumbSwiper :images="post.imageList" v-if="!loading">

          <template #mark>
            <div class="gallery-item__label">
              <span v-if="post.property.top == 4" class="top-tag">置顶</span>
              <span v-if="post.property.top == 3" class="good-tag">推荐</span>
              <span v-if="post.property.marked == 1" class="mark-tag">加急</span>
              <span v-if="post.property.good == 1" class="good-tag">精选</span>
            </div>
          </template>
          <div class="gallery-item" slot-scope="{ image }">
            <YorkbbsImage class="gallery-item__cover" :src="image | webpFormat(650)" :preview-src-list="post.imageList">
            </YorkbbsImage>
            <!-- <img
              class="gallery-item__label"
              :src="require('@/assets/images/car/label_urgent.png')"
              v-if="post.property.marked == 1"
            /> -->

          </div>

        </YorkbbsThumbSwiper>
        <!-- 标题 -->
        <el-skeleton :loading="loading" animated>
          <template slot="template">

            <el-skeleton-item variant="p" style="height: 66px; margin-bottom:50px" />

          </template>
        </el-skeleton>
        <div class="post-title" v-if="!loading">
          <div class="main-title">{{ post.title }} <span v-if="post.property.source == 1" class="custom-sale">{{
            sourceStatus }}</span>
            <span v-if="post.property.source == 2" class="shop-sale">{{ sourceStatus }}</span>
          </div>

        </div>
        <!-- 公里数（仅二手车） -->
        <!-- <div class="used-km" v-if="topic.englishName === 'used'">
          <img
            class="post-label__shop"
            :src="require('@/assets/images/car/label_shop.png')"
            v-if="post.property.source === 2"
          />
          <span>现公里数 {{ post.property.existingKM | distanceFormat }}km</span>
        </div> -->
        <!-- 价钱（仅二手车） -->
        <!-- <div class="post-price__used" v-if="topic.englishName === 'used'">${{ post.property.price | moneyFormat }}</div> -->
        <div class="post-price__used" v-if="topic.englishName === 'used'">

          <div class="lease-payment">

            <span class="lease-price__num"> ${{ post.property.price | moneyFormat }}</span>
            <span class="lease-price__label">全款</span>
          </div>
        </div>

        <!-- 拿回首付、月供（仅转Lease） -->
        <div class="post-price__lease" v-if="topic.englishName === 'lease'">
          <div class="lease-payment">

            <span class="lease-price__num">${{ Math.abs(post.property.downPayments) | moneyFormat }}</span>
            <span class="lease-price__label" v-if="post.property.downPayments >= 0">拿回首付</span>
            <span class="lease-price__label" v-else>首付返现</span>
          </div>
          <div class="lease-monthly">

            <span class="lease-price__num">${{ post.property.monthlySupply | moneyFormat }}</span>
            <span class="lease-price__label">税后月供</span>
          </div>
          <div class="lease-preDownpay" v-if="post.property.preDownPayments">
            <span class="lease-price__label">${{ post.property.preDownPayments | moneyFormat }} 原首付</span>
          </div>
        </div>
        <!-- 联系方式 -->
        <ul class="interact">
          <li v-if="post.property.contactNumber">
            <el-popover placement="bottom-start" width="350" trigger="hover">
              <el-button slot="reference" type="danger">
                <div class="phone-row"><img :src="require('@/assets/images/job/phone-white.png')" alt="" height="20">
                  电话</div>
              </el-button>
              <div class="popover-contact">
                <div class="phone-copy">
                  <div class="phone">{{ post.property.contactNumber | phoneFormat }}</div>
                  <div class="copy"><a :href="'https://www.google.com/search?q=' + post.property.contactNumber"
                      target="_blank">搜一下</a></div>
                  <div class="copy" v-clipboard:copy="post.property.contactNumber"
                    v-clipboard:success="() => $success('复制成功')">复制</div>
                </div>
                <div class="note">联系我时，请说是在约克论坛看到的。</div>
              </div>
            </el-popover>
          </li>
          <li>
            <a target="_blank" :href="chatURL" v-if="isLogin">
              <el-button plain>
                <div class="report-row"><img :src="require('@/assets/images/job/msg.png')" alt=""> 私信</div>
              </el-button>
            </a>
            <el-button plain @click="$store.commit('showLoginDialog')" v-else>
              <div class="report-row"><img :src="require('@/assets/images/job/msg.png')" alt=""> 私信</div>
            </el-button>
          </li>
          <li v-if="post.property.email">
            <el-popover placement="bottom-start" width="400" trigger="hover">
              <el-button slot="reference" plain>
                <div class="report-row">
                  <img :src="require('@/assets/images/job/email.png')" alt="">
                  Email
                </div>
              </el-button>
              <div class="popover-email">
                <div class="email-cont">{{ post.property.email }}</div>
                <div class="copy"><a :href="'https://www.google.com/search?q=' + post.property.email"
                    target="_blank">搜一下</a></div>
                <div class="copy" v-clipboard:copy="post.property.email" v-clipboard:success="() => $success('复制成功')">
                  复制</div>
                <a class="send-email" :href="'mailto:' + post.property.email">发送Email</a>
              </div>
            </el-popover>
          </li>
          <li v-if="post.property.weChatId || post.property.weChatQrcode">
            <el-popover placement="bottom-start" width="400" trigger="hover">
              <el-button slot="reference" plain>
                <div class="report-row">
                  <img :src="require('@/assets/images/job/wx.png')" alt="">
                  微信号
                </div>
              </el-button>
              <div class="popover-email">
                <div class="email-cont" v-if="post.property.weChatQrcode">
                  <img :src="post.property.weChatQrcode" class="qrcode-pic">
                </div>
                <div class="email-cont">{{ post.property.weChatId }}</div>
                <div class="copy" v-clipboard:copy="post.property.weChatId"
                  v-clipboard:success="() => $success('复制成功')" v-if="post.property.weChatId">复制
                </div>
              </div>
            </el-popover>
          </li>
          <li v-loading="favoriteLoading">
            <div class="collect-btn" @click="collectChange">
              <img :src="require('@/assets/images/common/collect-active.png')" alt="" v-if="post.property.isFavorite">
              <img :src="require('@/assets/images/common/collect-default.png')" alt="" v-else>
              收藏
            </div>
          </li>
          <li>
            <YorkbbsWechatSharePopover placement="bottom">
              <el-button plain>
                <div class="report-row"><img :src="require('@/assets/images/job/share.png')" alt=""> 分享</div>
              </el-button>
            </YorkbbsWechatSharePopover>
          </li>
        </ul>
        <!-- 车辆信息 -->
        <div class="post-config">
          <dt class="post-config__header">车辆信息</dt>
          <div class="car-set-config">
            <div class="lit" v-if="topic.englishName === 'lease' && post.property.lastTime">
              <div class="post-value">{{ expireTime }}</div>
              <div class="post-label">到期时间</div>
            </div>
            <div class="lit" v-if="post.property.remainingKM">
              <div class="post-value">{{ post.property.remainingKM | distanceFormat }}km</div>
              <div class="post-label">剩余公里数</div>
            </div>
            <div class="lit" v-if="post.property.existingKM">
              <div class="post-value">{{ post.property.existingKM | distanceFormat }}km</div>
              <div class="post-label">现公里数</div>
            </div>
            <div class="lit" v-if="post.property.fuelType">
              <div class="post-value">{{ fuelType }}</div>
              <div class="post-label">能源</div>
            </div>
            <div class="lit" v-if="post.property.transferFeePayer">
              <div class="post-value">{{ transferFeePayer }}</div>
              <div class="post-label">转车费用</div>
            </div>
            <div class="lit" v-if="post.property.buyerLimit">
              <div class="post-value">{{ buyerLimit }}</div>
              <div class="post-label">身份限制</div>
            </div>
            <!--             <div class="lit">
              <div class="post-value" v-if="post.property.extraurl">Carproof/CarFax</div>
              <div class="post-value" v-if="!post.property.extraurl">未提供</div>
              <div class="post-label" v-if="post.property.extraurl"><a :href="post.property.extraurl" target="_blank"><img :src="require('@/assets/images/car/extraurl.png')"></a></div>
              <div class="post-label" v-else><img :src="require('@/assets/images/car/extraurl-gavy.png')"></div>
            </div> -->
            <div class="lit" v-if="post.property.buyout">
              <div class="post-value">${{ post.property.buyout | moneyFormat }}</div>
              <div class="post-label">税前买断</div>
            </div>
            <div class="lit" v-if="post.property.deposit">
              <div class="post-value">${{ post.property.deposit | moneyFormat }}</div>
              <div class="post-label">押金金额</div>
            </div>

          </div>
        </div>
        <!---车辆配置--->
        <div class="cars-config">
          <div class="post-config__header">车辆配置</div>
          <div class="config-cont">
            <div class="insurance" v-if="post.property.topics[0].englishName == 'lease'">
              <div class="lit">
                <div class="box">
                  <div class="ico"><img :src="require('@/assets/images/car/insurance-1.png')" alt=""></div>
                  <div class="lab-txt">{{ post.property.haveTireInsurance == 1 ? '有' : '无' }}轮胎保险</div>
                </div>

              </div>
              <div class="lit">
                <div class="box">
                  <div class="ico"><img :src="require('@/assets/images/car/insurance-2.png')" alt=""></div>
                  <div class="lab-txt">{{ post.property.haveCarInsurance == 1 ? '有' : '无' }}还车保险</div>
                </div>
              </div>
            </div>
            <div class="func-config">
              <template v-for="(item, i) in post.property.otherConfig">
                <div class="post-config__item" :key="`otherConfig-${i}`" v-if="item.type != 'fuelType'">
                  <i class="ico el-icon-success"></i>
                  <div class="post-config__label">{{ item.name }}</div>
                </div>
              </template>

              <div class="post-config__item" v-for="(item, i) in post.property.config" :key="`config-${i}`">
                <i class="ico el-icon-success"></i>
                <div class="post-config__label">{{ item.name }}</div>
              </div>

            </div>
          </div>
        </div>
        <!-- 详情 -->
        <div class="post-config__header">车主补充</div>
        <div class="post-detail">

          <!-- 标签 -->
          <ul class="post-tag" v-if="post.property.tags && post.property.tags.length">
            <li class="post-tag__item" v-for="(item, i) in post.property.tags" :key="i">{{ item.name }}</li>
          </ul>
          <!-- 内容 -->
          <div v-if="post.contentJson && post.contentJson.length > 0" class="post-content editor-txt-content"
            v-html="ContentLinkAddRel(post.content)"></div>
          <div v-else class="no-content">
            <img :src="require('@/assets/images/car/no-data.png')" alt="">
            <div class="txt">该车主暂无补充</div>
          </div>

          <!-- 修改时间和访问量 -->
          <div class="post-time-view">
            <div class="post-time">
              <i class="yk-car_clock"></i>
              <span>{{ post.property.updatedAt | timeToStr }}更新</span>
            </div>
            <div class="post-time" v-if="post.property.ipPosition.city">
              <i class="yk-position"></i>
              <span>{{ post.property.ipPosition.city }}</span>
            </div>
            <div class="flex-cont"></div>

            <div class="post-view">
              <i class="yk-car_view"></i>
              <span>{{ post.property.view | numberFormat }}</span>
            </div>
          </div>
        </div>
        <!-- 汽车配置 -->
        <!-- <dl class="post-config" v-if="post.property.config && post.property.config.length">
          <dt class="post-config__header">更多配置</dt>
          <dd class="post-config__list">
            <div class="post-config__item" v-for="(item, i) in post.property.config" :key="`config-${i}`">
              <img class="post-config__logo" :src="item.image" :alt="item.name" />
              <div class="post-config__name">{{ item.name }}</div>
            </div>
            <div class="post-config__item" v-for="(item, i) in post.property.otherConfig" :key="`otherConfig-${i}`">
              <img class="post-config__logo" :src="item.image" :alt="item.name" />
              <div class="post-config__name">{{ item.name }}</div>
            </div>
          </dd>
        </dl> -->
        <!-- 位置 -->
        <div class="post-location" v-if="post.property.cityName">
          <div class="cont-row">
            <div class="post-location__header">看车地点</div>
            <div class="flex-cont"></div>
            <div class="post-location__info">
              <i class="yk-car_location"></i>
              <span class="post-location__city">{{ post.property.cityName }}</span>
              <span class="post-location__distance" v-if="post.distance">距你 {{ post.distance | distanceFormat
                }}km</span>
            </div>
          </div>

          <YorkbbsMap v-if="post.location.lon" class="post-map" :width="650" :height="130"
            :position="{ lat: post.location.lat, lng: post.location.lon }"
            :detail-visible="Boolean(post.property.showMyDetailAddress)"></YorkbbsMap>
        </div>

        <!-- 举报 -->
        <YorkbbsReportCard text="
            本网站所刊载的各类车辆信息（包含但不限于车型、车况等）来源于发布者，约克论坛仅为提供更多信息，不承担任何法律责任。任何付定金、押金等行为需谨慎，谨防诈骗！
          " @buttonClicked="reportVisible = true"></YorkbbsReportCard>
      </div>
      <div class="page-right">
        <!-- <YorkbbsUserCard
          v-if="post.id"
          :user="{
            id: post.user.id,
            avatar: post.user.avatar,
            username: post.user.username,
            registerTime: post.user.registerTime,
            latestVisitTime: post.user.latestVisitTime,
          }"
          :focusedByMe.sync="post.property.focusedByMe"
        ></YorkbbsUserCard>
        <YorkbbsMemberCard v-if="post.id" :data="post"></YorkbbsMemberCard> -->
        <el-skeleton :loading="loading" animated>
          <template slot="template">
            <el-skeleton-item variant="image" style="height: 377px; margin-bottom:20px" />


          </template>
        </el-skeleton>
        <DetailUserInfo v-if="post.id" :user="{
          id: post.user.id,
          avatar: post.user.avatar,
          username: post.user.username,
          registerTime: post.user.registerTime,
          latestVisitTime: post.user.latestVisitTime,
          phoneAuth: post.user.phoneAuth
        }" :focusedByMe.sync="post.property.focusedByMe" :data="post" />
        <!-- 广告 -->
        <div class="kjwt-column">
          <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`right_${i}`]"></YorkbbsAdvItem>
        </div>
      </div>
    </main>
    <div class="page-wrapper">
      <!-- Ta的车源 -->
      <dl class="his-car" v-if="hisCar.list.length">
        <dt class="his-car__header">Ta的车源</dt>
        <dd class="his-car__list">
          <template v-for="(item, i) in hisCar.list">
            <YorkbbsUsedItem class="his-car__item" :key="`used-${i}`" :data="item"
              v-if="item.property.topics[0].englishName === 'used'"></YorkbbsUsedItem>
            <YorkbbsLeaseItem class="his-car__item" :key="`lease-${i}`" :data="item"
              v-else-if="item.property.topics[0].englishName === 'lease'"></YorkbbsLeaseItem>
          </template>
        </dd>
      </dl>
      <!-- 为你推荐 -->
      <dl class="recomm-car" v-if="recommCar.list.length">
        <dt class="recomm-car__header">为你推荐</dt>
        <dd class="recomm-car__list">
          <template v-for="(item, i) in recommCar.list">
            <YorkbbsUsedItem class="recomm-car__item" :key="`used-${i}`" :data="item"
              v-if="item.property.topics[0].englishName === 'used'"></YorkbbsUsedItem>
            <YorkbbsLeaseItem class="recomm-car__item" :key="`lease-${i}`" :data="item"
              v-else-if="item.property.topics[0].englishName === 'lease'"></YorkbbsLeaseItem>
          </template>
        </dd>
      </dl>
    </div>

    <!-- 底部 -->
    <YorkbbsFooter class="page-footer" v-if="post.id"></YorkbbsFooter>

    

    <!-- 返回顶部 -->
    <YorkbbsBackup :publishVisible="true" :publishTitle="'卖车'"
      :publishURL="$router.resolve({ name: 'Publish', params: { topic: $route.params.topic || 'used' } })['href']"
      :homeVisible="true" :homeURL="'/center/information?type=4' | hostBuild('home')" :opinionVisible="true">
    </YorkbbsBackup>

    <!-- 举报对话框 -->
    <YorkbbsReportDialog :visible.sync="reportVisible" :list="reportList"></YorkbbsReportDialog>
  </div>
</template>
<script>
import { bannerAdvConvert, setHtmlMeta, specialSymbol2String, ContentLinkAddRel, hostBuild } from '@/utils/utils';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsFooter from '@/common/footer/footer.vue';
import YorkbbsBreadcrumb from '@/common/breadcrumb.vue';
import YorkbbsThumbSwiper from '@/common/swiper/swiper-thumb.vue';
import YorkbbsMap from '@/common/google-map/google-static-map.vue';
import DetailUserInfo from '@/common/detail-user-info.vue'
import YorkbbsUsedItem from '../components/item-used.vue';
import YorkbbsLeaseItem from '../components/item-lease.vue';
import YorkbbsPostTools from '@/common/tools-share.vue';
import YorkbbsReportCard from '@/common/card-report.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsReportDialog from '@/common/dialog-report.vue';
import YorkbbsAdvItem from '@/common/item-adv.vue';
import { sources, fuelTypes } from '../components/data';
import CarManagement from './car-manger.vue'
import YorkbbsAuthorManager from './author-manager.vue';
import YorkbbsWechatSharePopover from '@/common/popover-share-wechat.vue';
import YorkbbsSkeleton from '@/common/skeleton.vue';
export default {
  name: 'Detail',
  components: {
    YorkbbsHeader,
    YorkbbsFooter,
    YorkbbsBreadcrumb,
    YorkbbsMap,
    YorkbbsThumbSwiper,
    YorkbbsUsedItem,
    YorkbbsLeaseItem,
    YorkbbsPostTools,
    YorkbbsReportCard,
    YorkbbsBackup,
    YorkbbsReportDialog,
    YorkbbsAdvItem,
    DetailUserInfo,
    CarManagement,
    YorkbbsAuthorManager,
    YorkbbsWechatSharePopover,
    YorkbbsSkeleton,
  },
  data() {
    return {
      // 详情加载状态
      loading: false,
      // 详情
      post: {
        id: '',
        imageList: [],
        title: '',
        content: '',
        distance: '',
        property: {
          updatedAt: '',
          topics: [{}],
          config: [],
          otherConfig: [],
          tags: [],
          ipPosition: {
            city: '',
          },
          contactName: '',
          contactNumber: '',
          cityName: '',
          showMyDetailAddress: 0,
          existingKM: '',
          remainingKM: '',
          lastTime: '',
          source: 0,
          view: 0,
          price: '',
          downPayments: '',
          monthlySupply: '',
          isFavorite: 0,
        },
        location: {
          lon: '',
          lat: '',
        },
        user: {
          id: '',
          avatar: '',
          username: '',
          registerTime: '',
          latestVisitTime: '',
          focusedByMe: 0,
        },
        loginUserInfo: {}
      },
      // 为你推荐
      recommCar: {
        loading: false,
        list: [],
      },
      // 它的房源
      hisCar: {
        loading: false,
        list: [],
      },
      // 收藏加载状态
      favoriteLoading: false,

      // 举报对话框显示状态
      reportVisible: false,
      // 举报列表
      reportList: [{ name: '虚假车源' }, { name: '信息描述不实' }, { name: '垃圾广告' }, { name: '其它' }],

      // 广告
      adv: {},
      advLoading: false,
      // 车主身份列表
      sources: sources,
      // 能源列表
      fuelTypes: fuelTypes,
    };
  },
  computed: {
    // 是否登录
    isLogin() {
      return this.$store.getters.isLogin;
    },
    user() {
      return this.$store.getters.user;
    },
    // 当前板块
    topic() {
      return this.post.property.topics[0] || {};
    },
    // 到期时间
    expireTime() {
      const t = this.post.property.lastTime + '' || '';
      return `${t.slice(0, 4)}-${t.slice(4, 6)}`;
    },
    sourceStatus() {
      let name = '';
      for (var i = 0; i < this.sources.length; i++) {
        if (this.sources[i].id == this.post.property.source) {
          name = this.sources[i].name;
          break;
        }
      }
      return name;
    },
    //能源类型
    fuelType() {
      let name = '';
      for (var i = 0; i < this.fuelTypes.length; i++) {
        if (this.fuelTypes[i].id == this.post.property.fuelType) {
          name = this.fuelTypes[i].name
          break;
        }
      }
      return name;
    },
    //转车费用谁出
    transferFeePayer() {
      let name = '';
      switch (this.post.property.transferFeePayer) {
        case 1:
          name = '买家承担';
          break;
        case 2:
          name = '卖家承担';
          break;
        case 3:
          name = '双方AA';
          break;
        default:
          name = '面议'
      }
      return name;
    },
    //身份限制
    buyerLimit() {
      let name = '';
      switch (this.post.property.buyerLimit) {
        case 1:
          name = '学签、工签、本地人均可';
          break;
        case 2:
          name = 'PR/Citizen/工签持有者可签';
          break;
        case 3:
          name = '仅限PR/Citizen';
          break;
      }
      return name;
    },
    chatURL() {
      return hostBuild(`/chat?to=${this.post.user.id}`, 'home');
    },


  },
  created() {
    this.getPost();

    this.getAdvList();
  },
  methods: {
    ContentLinkAddRel(data) {
      return ContentLinkAddRel(data);
    },
    /**
     * Ta的房源
     */
    async getHisCars() {
      this.hisCar.loading = true;
      const { data } = await this.$axios
        .post('/car/v1/get/his/post/list', {
          userId: this.post.user.id,
          postId: this.post.id,
          offset: 1,
          size: 6,
        })
        .finally(() => {
          this.hisCar.loading = false;
        });

      this.hisCar.list = data.items;
    },
    /**
     * 为你推荐汽车列表
     */
    async getRecommandCars() {
      this.recommCar.loading = true;
      const { data } = await this.$axios
        .post('/car/v1/get/recommend/list', {
          postId: this.$route.params.id,
          offset: 1,
          size: 6,
          topicIds: [this.topic.id],
        })
        .finally(() => {
          this.recommCar.loading = false;
        });

      this.recommCar.list = data.items;
    },
    /**
     * 获取信息详情
     */
    async getPost() {
      this.loading = true;
      const { code, msg, data } = await this.$axios
        .post('/car/v1/get/post/detail', {
          postId: this.$route.params.id,
          longitude: this.$store.getters.position.longitude,
          latitude: this.$store.getters.position.latitude,
          distance: 500000,
        })
        .finally(() => {
          this.loading = false;
        });

      if (code == -3) {
        this.$error(msg);
        return this.$router.replace('/');
      }

      this.post = data;

      let topicStr = this.$route.params.topic == 'used' ? '二手车出售' : '转Lease';
      let descriptionStr = `${data.property.cityName == 'Others' ? '' : data.property.cityName}${data.property.brand.nameCN}${data.property.brand.name}${topicStr}，`;
      descriptionStr += `${data.property.year}款${data.property.modal.name}，`;
      let keywordStr = '';
      if (this.$route.params.topic == 'used') {
        descriptionStr += `价格$${data.property.price / 100}，`
        keywordStr = '多伦多二手车,买车,卖车,代卖,汽车经纪,汽车销售,0首付,0dp,补贴,car,auto,used car'
      }
      if (this.$route.params.topic == 'lease') {
        descriptionStr += `月供$${data.property.monthlySupply / 100}，`
        keywordStr = '多伦多二手车,转lease,转车,求lease,还车保险,0首付,0dp,补贴,多伦多二手车,汽车经纪,汽车销售,car auto,used car'
      }
      descriptionStr += `${specialSymbol2String(data.content).substr(0, 30)}。yorkbbs.ca`
      setHtmlMeta({
        title: `${data.title} -多伦多${this.$route.params.topic == 'used' ? '二手车' : '转Lease'} - 多伦多汽车 - 约克论坛`,
        keywords: keywordStr,
        description: descriptionStr,
      });

      this.getRecommandCars();
      this.getHisCars();
    },
    /**
     * 收藏
     */
    async addFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/car/v1/add/favorite/item', {
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.favoriteLoading = false;
        });

      this.$success('收藏成功');
      this.post.property.isFavorite = true;
      this.post.property.favorite += 1;
    },
    /**
     * 取消收藏
     */
    async removeFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/car/v1/remove/favorite/item', {
          ids: [this.$route.params.id],
        })
        .finally(() => {
          this.favoriteLoading = false;
        });

      this.$success('取消收藏成功');
      this.post.property.isFavorite = false;
      this.post.property.favorite -= 1;
    },
    /**
     * 获取广告
     */
    async getAdvList() {
      const zoomId = 4567;
      const { data } = await this.$axios.post('/crm/section/v1/get/list/open', { id: zoomId });

      this.adv = bannerAdvConvert(data, 'car', zoomId);
    },

    collectChange() {
      if (this.post.property.isFavorite) {
        //取消收藏
        this.removeFavorite();
      } else {
        this.addFavorite();
      }
    },
    /**
     * 收藏
     */
    async addFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/job/v1/add/favorite/item', {
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.favoriteLoading = false;
        });

      this.$success('收藏成功');
      this.post.property.isFavorite = true;
      this.post.property.favorite += 1;
    },
    /**
     * 取消收藏
     */
    async removeFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/job/v1/remove/favorite/item', {
          ids: [this.$route.params.id],
        })
        .finally(() => {
          this.favoriteLoading = false;
        });

      this.$success('取消收藏成功');
      this.post.property.isFavorite = false;
      this.post.property.favorite -= 1;
    },
  },

};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
}

.page-wrapper {
  width: 1000px;
  margin: auto;
}

.page-main {
  width: 1000px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.page-left {
  width: 650px;
}

.page-right {
  width: 300px;
}

.page-footer {
  margin-top: 130px;
}

.gallery-item {
  position: relative;
}

.gallery-item__cover {
  box-sizing: border-box;
  width: 650px;
  height: 400px;
  border-radius: 6px;
  border: 1px solid #eee;
}

/* .gallery-item__label {
  position: absolute;
  left: 0;
  top: 0;
  width: 74px;
  z-index: 1;
} */
.gallery-item__label {
  position: absolute;
  z-index: 22;
  left: 20px;
  top: 20px;
  display: flex;

  span {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    width: 50px;
    justify-content: center;
    color: #fff;
    border-radius: 4px;
    margin-right: 10px;
    background: #e43a3a;

    &.mark-tag {
      background: #ff5806;
    }
  }
}

.post-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .main-title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-right: 10px;
    word-break: break-all;

    span {
      display: inline-block;
      width: 68px;
      line-height: 24px;
      border-radius: 2px;
      color: #fff;
      font-size: 14px;
      text-align: center;

      &.shop-sale {
        background: #ff6900;
      }

      &.custom-sale {
        background: #027bf9;
      }
    }
  }


}

.used-km {
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 15px;
  color: var(--text-color-6);
}

.post-price__used {
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  line-height: 30px;
  margin-bottom: 50px;
}

.lease-km__wrapper {
  display: flex;
  margin-bottom: 15px;
}

.lease-km,
.lease-time {
  font-size: 16px;
  line-height: 20px;
  color: var(--text-color-6);
}

.lease-time {
  position: relative;
  margin-left: 20px;

  &::before {
    content: '|';
    display: inline-block;
    font-size: 14px;
    position: absolute;
    left: -10px;
    top: -1px;
  }
}

.post-price__lease {
  display: flex;
  align-items: baseline;
  margin-bottom: 50px;
}

.lease-payment,
.lease-monthly {
  display: flex;
  align-items: baseline;
  color: var(--primary-color);
  margin-right: 20px;
}

.lease-price__label {
  font-size: 16px;
  margin-left: 5px;
  line-height: 24px;
  margin-right: 6px;
  color: #999;
}

.lease-price__num {
  font-size: 24px;
  font-weight: 700;
  line-height: 25px;
}

.lease-payment {
  margin-right: 25px;
}

.post-label__shop {
  height: 20px;
  margin-right: 6px;
}

.post-tag {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.post-tag__item {
  display: inline-flex;
  height: 32px;
  padding: 0 10px;
  background: #f8f8f8;
  border-radius: 4px;
  font-size: 14px;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 12px;
}

.post-detail {
  border: 1px solid #eeeeee;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 50px;
}

.post-content {
  padding: 0;
  font-size: 18px;
  min-height: 100px;
  overflow: hidden;
}

.post-time-view {
  display: flex;
  align-items: center;
}

.post-time-view .post-time {
  margin-right: 10px;
}

.post-time-view .flex-cont {
  flex: 1;
}

.post-time,
.post-view {
  line-height: 30px;
  border-radius: 15px;
  padding: 0 10px;
  font-size: 14px;
  color: var(--text-color-6);
  background-color: #f8f8f8;

  i {
    font-size: 12px;
    color: var(--text-color-9);
    margin-right: 6px;
  }
}

.post-config {
  margin-bottom: 46px;
}

.post-config__header {
  font-size: 18px;
  color: var(--text-color-9);
  line-height: 25px;
  margin-bottom: 14px;
}

.post-config__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #eeeeee;
  background: #fff;
}

.post-config__item {
  text-align: center;
  width: calc(100% / 7);

  &:nth-child(n + 8) {
    margin-top: 20px;
  }
}

.post-config__logo {
  width: 25px;
}

.post-config__name {
  font-size: 14px;
  line-height: 20px;
  margin-top: 5px;
}

.post-location {
  margin-bottom: 50px;
}

.post-location__header {
  font-size: 18px;
  color: var(--text-color-9);
  line-height: 25px;
  margin-bottom: 14px;
}

.post-location__info {
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 13px;

  i {
    font-size: 14px;
    color: var(--text-color-9);
    margin-right: 5px;
  }
}

.post-location__distance {
  margin-left: 20px;
}

.his-car,
.recomm-car {
  margin-bottom: 30px;
}

.his-car__header,
.recomm-car__header {
  font-size: 18px;
  color: var(--text-color-9);
  line-height: 25px;
  margin-bottom: 14px;
}

.his-car__list,
.recomm-car__list {
  display: flex;
  flex-wrap: wrap;
}

.his-car__item,
.recomm-car__item {
  width: 310px;

  &:nth-child(3n + 2) {
    margin-left: 35px;
    margin-right: 35px;
  }
}

::v-deep {
  .kjwt-column {
    .kjwt-item {
      margin-bottom: 10px;
    }

    padding-bottom: 10px;
  }

  .kjwt-row {
    width: 1170px;
    display: flex;
    margin: 0 auto;
    justify-content: center;

    .kjwt-item {
      margin: 10px 0;
    }

    .kjwt-item+.kjwt-item {
      margin-left: 10px;
    }
  }
}

.car-set-config {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 5px 20px 15px;
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;

  .lit {
    width: 33.33%;
    padding: 9px 0;
    text-align: center;

    .post-value {
      font-size: 16px;
      font-weight: bold;
      line-height: 30px;
    }

    .post-label {
      font-size: 14px;
      color: #999;
    }
  }
}

.cars-config {
  .config-cont {
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 30px 0;
    margin-bottom: 50px;

    .insurance {
      display: flex;
      padding-left: 30px;
      margin-bottom: 10px;

      .lit {
        width: 25%;
        display: flex;

        .ico {

          img {
            display: block;
            margin: 0 auto;
          }
        }

        .lab-txt {
          font-size: 16px;
          line-height: 20px;
          color: #999;
          margin-top: 6px;
        }
      }
    }

    .func-config {
      display: flex;
      flex-wrap: wrap;
      padding-left: 30px;

      .post-config__item {
        display: flex;
        width: 25%;
        align-items: center;
        font-size: 16px;
        line-height: 20px;
        color: #111;
        margin-top: 10px;

        i {
          color: #4DB944;
          font-size: 18px;
        }

        .post-config__label {
          margin-left: 5px;
        }
      }
    }
  }
}

.cont-row {
  display: flex;
}

.cont-row .flex-cont {
  flex: 1
}

.my-sell {
  color: var(--primary-color);
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  text-decoration: underline;
}

.no-content {
  padding: 40px 0 30px;
  text-align: center;

  img {
    display: block;
    margin: 0 auto 20px;
  }

  .txt {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-9);
  }
}

.interact {
  display: flex;
  align-content: center;
  margin-bottom: 30px;
  font-size: 20px;

  li {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  i {
    font-size: 20px;
  }

  ::v-deep {
    .el-button {
      padding: 10px 16px;

    }
  }
}

.phone-row {
  display: flex;
  align-items: center;
  font-size: 15px;

  img {
    margin-right: 8px;
  }
}

.popover-contact {
  .phone-copy {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .phone {
      flex: 1;
      font-size: 22px;
      line-height: 33px;
      color: var(--primary-color);
      font-weight: bold;
    }

    .copy {
      font-size: 14px;
      line-height: 20px;
      color: #333;
      cursor: pointer;
      user-select: none;
      margin-right: 20px
    }
  }

  .contact {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-3);
    margin-bottom: 10px;
  }

  .note {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-9);
  }


}

.report-row {
  display: flex;
  align-items: center;
  font-size: 15px;

  img {
    height: 20px;
    margin-right: 8px;
  }
}

.collect-btn {
  display: flex;
  align-items: center;
  padding: 0 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  line-height: 40px;
  cursor: pointer;
  user-select: none;

  img {
    display: inline-block;
    height: 20px;
    margin-right: 5px;
  }

  &:hover {
    border-color: #e43a3a;
  }
}
.popover-email {
  display: flex;
  align-items: center;
  padding: 0 15px;
  font-size: 14px;
  color: var(--text-color-3);

  .email-cont {
    font-size: 16px;
    font-weight: bold;
    line-height: 36px;
    color: var(--primary-color);
    flex: 1;
    padding-left: 10px;
  }

  .copy {
    line-height: 20px;
    color: #333;
    cursor: pointer;
    user-select: none;
    margin-right: 20px;
  }

  .send-email {
    line-height: 20px;
  }
}

</style>
